import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

export const loadModel = (path, position, scale, rotation) => {
  return new Promise((resolve, reject) => {
    const loader = new GLTFLoader();

    loader.load(path, (gltf) => {
      const model = gltf.scene;

      model.position.set(position.x, position.y, position.z);
      model.scale.set(scale.x, scale.y, scale.z);
      model.rotation.set(rotation.x, rotation.y, rotation.z);

      // Calculer les arêtes du modèle
      model.traverse((child) => {
        if (child.isMesh) {
          const edges = new THREE.EdgesGeometry(child.geometry);
          const line = new THREE.LineSegments(
            edges,
            new THREE.LineBasicMaterial({ color: 0x000000 }),
          );
          child.add(line);
          child.material.transparent = true; // Permettre la transparence
        }
      });

      resolve(model);
    });
  });
};

export const createSkipWithAlert = async (
  skipConfig,
  alertConfig,
  scene,
  skipModelsRef,
  alertSkipModelsRef,
) => {
  const { modelPath, position, scale, rotation, dimensions } = skipConfig;
  const { alertPath, alertScale } = alertConfig;

  // Si position représente le centre, mais le modèle a son origine au coin inférieur,
  // on doit décaler le modèle de -height/2 en Y pour aligner les centres
  const modelPosition = {
    x: position.x,
    y: position.y - (dimensions?.height || 0) / 2,
    z: position.z,
  };

  // Charger le modèle principal
  const skipModel = await loadModel(modelPath, modelPosition, scale, rotation);
  scene.add(skipModel);
  skipModelsRef.current.push(skipModel);

  // Charger le modèle d'alerte temporairement pour calculer son bounding box
  const tempAlertModel = await loadModel(
    alertPath,
    { x: 0, y: 0, z: 0 },
    alertScale,
    { x: 0, y: 0, z: 0 },
  );

  // Calculer le bounding box pour centrer le modèle
  const box = new THREE.Box3().setFromObject(tempAlertModel);
  const center = box.getCenter(new THREE.Vector3());
  const size = box.getSize(new THREE.Vector3());

  // Positionner l'alerte exactement au centre du conteneur, juste au-dessus
  const alertY = position.y + (dimensions?.height || 0) / 2 + size.y / 2 + 0.2;

  // Ajuster la position pour compenser le décalage du pivot du modèle
  const alertPosition = {
    x: position.x - center.x,
    y: alertY - center.y,
    z: position.z - center.z,
  };

  // Réinitialiser le modèle avec la bonne position et rotation
  tempAlertModel.position.set(
    alertPosition.x,
    alertPosition.y,
    alertPosition.z,
  );
  tempAlertModel.rotation.set(rotation.x, rotation.y, rotation.z);
  tempAlertModel.visible = false;
  scene.add(tempAlertModel);
  alertSkipModelsRef.current.push(tempAlertModel);
};
